import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { apiGifts } from '../../api/apiGifts.api';
import chatService from '../../services/chat.service';
import SendGiftsModal from '../../components/gifts/SendGiftsModal';
import { toast } from 'react-toastify';
import { useState } from 'react';
import config from '../../config';

export function RouletteOpenChat({ recipientId, disabled }) {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [isOpenGiftShop, setIsOpenGiftShop] = useState(false);

  const handleOpenGiftShop = () => {
    setIsOpenGiftShop(true);
  };

  const handleSendGifts = async (giftId) => {
    if (!recipientId) return;
    try {
      const res = await apiGifts.sendGift(axiosPrivate, { recipientId, giftId });
      if (res.data.data.ok) {
        await handleToFindOrCreateChat();
      }
    } catch (error) {
      console.error('[Roulette] Error sending gift:', error);
      toast.error(error.response.data.message || 'Ошибка отправки подарка');
    }
  };

  const handleToFindOrCreateChat = async () => {
    if (!recipientId) return;
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, recipientId);
      navigate(config.ROUTES.CHATS.TEXT(res.data._id));
    } catch (error) {
      console.error('[Roulette] getChatToUserId:', error);
      toast.error('Ошибка при попытке открыть чат с пользователем');
    }
  };

  return (
    <>
      <SendGiftsModal
        isOpen={isOpenGiftShop}
        onClose={() => setIsOpenGiftShop(false)}
        renderTitle={() => (
          <h2 className="text-[18px] font-semibold text-white text-center leading-[1.5] font-raleway">
            Обозначь себя, сделав человеку приятно. Это шаг к новым знакомствам!
          </h2>
        )}
        onSend={handleSendGifts}
      />
      <button disabled={disabled} className="size-[64px] disabled:opacity-50" onClick={handleOpenGiftShop}>
        <img className="w-full h-full" src="/icons/instr4.svg" />
      </button>
    </>
  );
}
